import { Select, OnScroll } from './helper';

const HeaderScrolled = {
  /**
   * Toggle .header-scrolled class to #header when page is scrolled
   */
  init() {
    this._selectBase = Select('base');
    this._baseAttribute = this._selectBase.getAttribute('class-attr');
    this._arrBaseAttribute = [
      'Home Page',
      'About Page',
      'Product Page',
      'Galeri Page',
      'Contact Page',
      'Product Spec',
      'Category Page',
      'Blog Page',
      'Blog Post',
      'Search Page',
      '404 Page'
    ];
    this._bgClass = this._arrBaseAttribute.includes(this._baseAttribute) ? 'bg-opacity-0' : 'bg-primary';
    this._selectHeader = Select('#masthead');
    this._selectNavToggler = Select('.nav-toggler');
    this._selectSearchToggler = Select('.search-toggler');

    this._initialListener();
  },


  _initialListener() {

    if (!this._selectHeader) return;

    window.addEventListener('load', () => {
      this._headerScrolled();
    });

    OnScroll(document, () => {
      this._headerScrolled();
    });
  },


  _headerScrolled() {
    if (window.scrollY > 100) this._siteHeaderBackgroundWhite();
    else  this._siteHeaderBackgroundTransparent();
  },


  _siteHeaderBackgroundWhite() {
    this._removeHeaderBackgroundClass();
    this._addHeaderScrolledClass();
    // this._navTogglerOutlineSecondary();
    // this._searchTogglerSecondary();
  },


  _siteHeaderBackgroundTransparent() {
    this._addHeaderBackgroundClass();
    this._removeHeaderScrolledClass();
    // this._navTogglerOutlineLight();
    // this._searchTogglerLight();
  },


  _removeHeaderBackgroundClass() {
    this._selectHeader.classList.remove(this._bgClass);
  },


  _addHeaderBackgroundClass() {
    this._selectHeader.classList.add(this._bgClass);
  },


  _removeHeaderScrolledClass() {
    this._selectHeader.classList.remove('header-scrolled');
  },


  _addHeaderScrolledClass() {
    this._selectHeader.classList.add('header-scrolled');
  },


  _navTogglerOutlineSecondary() {
    this._selectNavToggler.classList.remove('btn-outline-light');
    this._selectNavToggler.classList.add('btn-outline-secondary');
  },


  _navTogglerOutlineLight() {
    this._selectNavToggler.classList.remove('btn-outline-secondary');
    this._selectNavToggler.classList.add('btn-outline-light');
  },

  _searchTogglerSecondary() {
    this._selectSearchToggler.classList.remove('btn-outline-light');
    this._selectSearchToggler.classList.add('btn-outline-secondary');
  },


  _searchTogglerLight() {
    this._selectSearchToggler.classList.remove('btn-outline-secondary');
    this._selectSearchToggler.classList.add('btn-outline-light');
  }


};

export default HeaderScrolled;